import categories from "~/utils/categories-data.json";

export const useBlogListFetch = async () => {

	try {
		const category = ref();
		const config = useRuntimeConfig();
		const $route = useRoute();

		const API_ENDPOINT = `${config.public.hostname}wp-json/wp/v2/posts/`;

		const postShapeFormatter = (og_post, page) => {
			const { id, title, slug, categories, content, _embedded } = og_post;

			const image =
				_embedded["wp:featuredmedia"] && _embedded["wp:featuredmedia"][0]
					? _embedded["wp:featuredmedia"][0].source_url
					: null;
			return {
				id,
				title,
				slug,
				categories,
				image,
				page,
				content
			};
		};

		let category_id;

		if ($route.params && $route.params.slug) {
			const slug_arr = $route.params.slug.filter((item) => item !== "");

			const category_slug = slug_arr[slug_arr.length - 1];
			category.value = categories.find(
				(category) => category.slug === category_slug
			);

			category_id = category.value.id;
		}

		const pageNumber =
			$route.params && $route.params.page ? $route.params.page[0] : 1;

		let previousPageNumber = null;

		previousPageNumber = pageNumber > 2 ? pageNumber - 1 : null;

		const { data, headers } = await fetchPostsList(
			API_ENDPOINT,
			pageNumber,
			category_id
		);

		let category_meta;

		if (category_id) {
			const { yoast_head_json } = await $fetch(
				config.public.hostname + "wp-json/wp/v2/categories/" + category_id
			);

			category_meta = yoast_head_json;
		}

		const posts_formatted = data.map((post) =>
			postShapeFormatter(post, pageNumber)
		);

		return {
			list: posts_formatted,
			total_pages: headers["x-wp-totalpages"],
			pageNumber,
			previousPageNumber,
			category,
			category_meta
		};

	} catch (e) {
		console.log(e.code)
		return {
			error: e.code
		}
	}
};
